import { render, staticRenderFns } from "./MsiFooter.vue?vue&type=template&id=57e6ce49&"
import script from "./MsiFooter.vue?vue&type=script&lang=js&"
export * from "./MsiFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports